{
  "labels": {
    "signUp": "",
    "signIn": "",
    "paste": "Įklijuoti",
    "pasteAsPlaintext": "Įklijuoti kaip paprastą tekstą",
    "pasteCharts": "Įklijuoti diagramas",
    "chartType_bar": "",
    "chartType_line": "",
    "chartType_radar": "",
    "chartType_plaintext": "",
    "selectAll": "Pažymėti viską",
    "multiSelect": "Pridėkite elementą prie pasirinktų",
    "moveCanvas": "Judinti drobę",
    "cut": "Iškirpti",
    "copy": "Kopijuoti",
    "copyAsPng": "Kopijuoti į iškarpinę kaip PNG",
    "copyAsSvg": "Kopijuoti į iškarpinę kaip SVG",
    "copyText": "Kopijuoti į iškarpinę kaip tekstą",
    "copySource": "",
    "convertToCode": "",
    "bringForward": "Kelti priekio link",
    "sendToBack": "Nustumti į užnugarį",
    "bringToFront": "Iškelti į priekį",
    "sendBackward": "Nustumti link užnugario",
    "delete": "Ištrinti",
    "copyStyles": "Kopijuoti stilius",
    "pasteStyles": "Įklijuoti stilius",
    "stroke": "Linija",
    "changeStroke": "",
    "background": "Fonas",
    "changeBackground": "",
    "fill": "Užpildymas",
    "strokeWidth": "Linijos storis",
    "strokeStyle": "Linijos stilius",
    "strokeStyle_solid": "Ištisinė",
    "strokeStyle_dashed": "Brūkšniuota",
    "strokeStyle_dotted": "Taškuota",
    "sloppiness": "Netvarkingumas",
    "pressure": "",
    "pressure_constant": "",
    "pressure_variable": "",
    "opacity": "Nepermatomumas",
    "textAlign": "Teksto lygiavimas",
    "edges": "Kraštai",
    "sharp": "Aštrus",
    "round": "Užapvalintas",
    "arrowheads": "Rodyklės viršūnės",
    "arrowhead_none": "Jokios",
    "arrowhead_arrow": "Rodyklė",
    "arrowhead_bar": "Brukšnys",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "Trikampis",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "arrowhead_crowfoot_many": "",
    "arrowhead_crowfoot_one": "",
    "arrowhead_crowfoot_one_or_many": "",
    "arrowhead_cardinality_one": "",
    "arrowhead_cardinality_many": "",
    "arrowhead_cardinality_one_or_many": "",
    "arrowhead_cardinality_exactly_one": "",
    "arrowhead_cardinality_zero_or_one": "",
    "arrowhead_cardinality_zero_or_many": "",
    "more_options": "",
    "cardinality": "",
    "arrowtypes": "",
    "arrowtype_sharp": "",
    "arrowtype_round": "",
    "arrowtype_elbowed": "",
    "fontSize": "Šrifto dydis",
    "fontFamily": "Šriftas",
    "addWatermark": "Sukurta su Excalidraw",
    "handDrawn": "Ranka rašytas",
    "normal": "Normalus",
    "code": "Kodas",
    "small": "Mažas",
    "medium": "Vidutinis",
    "large": "Didelis",
    "veryLarge": "Labai didelis",
    "solid": "",
    "hachure": "",
    "zigzag": "",
    "crossHatch": "",
    "thin": "Plonas",
    "bold": "Pastorintas",
    "left": "Kairėje",
    "center": "Centre",
    "right": "Dešinėje",
    "extraBold": "Labiau pastorintas",
    "architect": "Architektas",
    "artist": "Menininkas",
    "cartoonist": "Karikatūristas",
    "fileTitle": "Failo pavadinimas",
    "colorPicker": "Spalvos parinkiklis",
    "canvasColors": "",
    "canvasBackground": "Drobės fonas",
    "drawingCanvas": "",
    "clearCanvas": "",
    "layers": "Sluoksniai",
    "actions": "Veiksmai",
    "language": "Kalba",
    "liveCollaboration": "Bendradarbiavimas gyvai...",
    "duplicateSelection": "",
    "untitled": "",
    "name": "",
    "yourName": "Jūsų vardas",
    "madeWithExcalidraw": "Sukurta su Excalidraw",
    "group": "Grupuoti pasirinkimą",
    "ungroup": "Išgrupuoti pasirinkimą",
    "collaborators": "Bendradarbiautojai",
    "you": "",
    "toggleGrid": "",
    "loadingScene": "",
    "loadScene": "",
    "align": "Lygiuoti",
    "alignTop": "Lygiuoti viršuje",
    "alignBottom": "Lygiuoti apačioje",
    "alignLeft": "Lygiuoti kairėje",
    "alignRight": "Lygiuoti dešinėje",
    "centerVertically": "Centruoti vertikaliai",
    "centerHorizontally": "Centruoti horizontaliai",
    "distributeHorizontally": "",
    "distributeVertically": "",
    "flipHorizontal": "Apversti horizontaliai",
    "flipVertical": "Apversti vertikaliai",
    "viewMode": "",
    "share": "Dalintis",
    "showStroke": "",
    "showBackground": "",
    "showFonts": "",
    "toggleTheme": "",
    "theme": "",
    "decreaseFontSize": "",
    "increaseFontSize": "",
    "unbindText": "",
    "bindText": "",
    "createContainerFromText": "",
    "link": {
      "edit": "Redeguoti nuorodą",
      "editEmbed": "",
      "create": "",
      "label": "Nuoroda",
      "labelEmbed": "",
      "empty": "",
      "hint": "",
      "goToElement": ""
    },
    "lineEditor": {
      "edit": "",
      "editArrow": ""
    },
    "polygon": {
      "breakPolygon": "",
      "convertToPolygon": ""
    },
    "elementLock": {
      "lock": "Užrakinti",
      "unlock": "Atrakinti",
      "lockAll": "",
      "unlockAll": ""
    },
    "sidebarLock": "",
    "selectAllElementsInFrame": "",
    "removeAllElementsFromFrame": "",
    "eyeDropper": "",
    "followUs": "",
    "discordChat": "",
    "zoomToFitViewport": "",
    "zoomToFitSelection": "",
    "zoomToFit": "",
    "installPWA": "",
    "autoResize": "",
    "imageCropping": "",
    "unCroppedDimension": "",
    "copyElementLink": "",
    "linkToElement": "",
    "wrapSelectionInFrame": "",
    "tab": "",
    "shapeSwitch": "",
    "preferences": "",
    "preferences_toolLock": "",
    "boxSelectionMode": "",
    "boxSelectionContain": "",
    "boxSelectionOverlap": "",
    "arrowBinding": "",
    "midpointSnapping": ""
  },
  "elementLink": {
    "title": "",
    "desc": "",
    "notFound": ""
  },
  "search": {
    "title": "",
    "noMatch": "",
    "singleResult": "",
    "multipleResults": "",
    "placeholder": "",
    "frames": "",
    "texts": ""
  },
  "buttons": {
    "clearReset": "",
    "exportJSON": "Eksportuoti į failą",
    "exportImage": "",
    "export": "",
    "copyToClipboard": "Kopijuoti į iškarpinę",
    "copyLink": "",
    "save": "",
    "saveAs": "Išsaugoti kaip",
    "load": "",
    "getShareableLink": "Gauti nuorodą dalinimuisi",
    "close": "Uždaryti",
    "selectLanguage": "Pasirinkite kalbą",
    "scrollBackToContent": "",
    "zoomIn": "Priartinti",
    "zoomOut": "Nutolinti",
    "resetZoom": "",
    "menu": "Meniu",
    "done": "",
    "edit": "Redaguoti",
    "undo": "Anuliuoti",
    "redo": "",
    "createNewRoom": "Sukurti naują kambarį",
    "fullScreen": "Visas ekranas",
    "darkMode": "Tamsus režimas",
    "lightMode": "Šviesus režimas",
    "systemMode": "",
    "zenMode": "„Zen“ režimas",
    "objectsSnapMode": "",
    "exitZenMode": "Išeiti iš „Zen“ režimo",
    "cancel": "Atšaukti",
    "clear": "Išvalyti",
    "remove": "Pašalinti",
    "embed": "",
    "submit": "Pateikti",
    "confirm": "Patvirtinti",
    "embeddableInteractionButton": ""
  },
  "alerts": {
    "clearReset": "",
    "couldNotCreateShareableLink": "",
    "couldNotCreateShareableLinkTooBig": "",
    "couldNotLoadInvalidFile": "",
    "importBackendFailed": "",
    "cannotExportEmptyCanvas": "",
    "couldNotCopyToClipboard": "",
    "decryptFailed": "",
    "uploadedSecurly": "",
    "loadSceneOverridePrompt": "",
    "collabStopOverridePrompt": "Sesijos nutraukimas perrašys ankstesnį, lokaliai išsaugotą piešinį. Ar tikrai to nori?\n\n(Jei nori išlaikyti lokalų piešinį, tiesiog uždaryk naršyklės skirtuką.)",
    "imageDoesNotContainScene": "Panašu, jog šis paveiksliukas neturi scenos duomenų. Ar yra įjuntas scenos įtraukimas ekportavimo metu?",
    "cannotRestoreFromImage": "Nepavyko atstatyti scenos iš šio nuotraukos failo",
    "invalidSceneUrl": "Nepavyko suimportuoti scenos iš pateiktos nuorodos (URL). Ji arba blogai suformatuota, arba savyje neturi teisingų Excalidraw JSON duomenų.",
    "invalidEncryptionKey": "Šifravimo raktas turi būti iš 22 simbolių. Redagavimas gyvai yra išjungtas.",
    "collabOfflineWarning": "",
    "localStorageQuotaExceeded": ""
  },
  "errors": {
    "unsupportedFileType": "Nepalaikomas failo tipas.",
    "imageInsertError": "Nepyko įkelti paveiksliuko. Pabandyk vėliau...",
    "fileTooBig": "Per didelis failas. Didžiausias leidžiamas dydis yra {{maxSize}}.",
    "svgImageInsertError": "Nepavyko įtraukti SVG paveiksliuko. Panašu, jog SVG yra nevalidus.",
    "failedToFetchImage": "",
    "cannotResolveCollabServer": "Nepavyko prisijungti prie serverio bendradarbiavimui. Perkrauk puslapį ir pabandyk prisijungti dar kartą.",
    "collabSaveFailed": "",
    "collabSaveFailed_sizeExceeded": "",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "",
      "line4": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "Žymėjimas",
    "lasso": "",
    "image": "Įkelti paveiksliuką",
    "rectangle": "Stačiakampis",
    "diamond": "Deimantas",
    "ellipse": "Elipsė",
    "arrow": "Rodyklė",
    "line": "Linija",
    "freedraw": "Piešti",
    "text": "Tekstas",
    "lock": "Baigus piešti, išlaikyti pasirinktą įrankį",
    "penMode": "Rašyklio režimas - neleisti prisilietimų",
    "link": "",
    "eraser": "Trintukas",
    "frame": "",
    "embeddable": "",
    "laser": "",
    "autoshape": "",
    "bucketfill": "",
    "hand": "",
    "extraTools": "",
    "convertElementType": ""
  },
  "bucketfill": {
    "noRegion": "",
    "tooComplex": ""
  },
  "element": {
    "rectangle": "",
    "diamond": "",
    "ellipse": "",
    "arrow": "",
    "line": "",
    "freedraw": "",
    "text": "",
    "image": "",
    "group": "",
    "frame": "",
    "embeddable": "",
    "selection": "",
    "iframe": ""
  },
  "headings": {
    "canvasActions": "Veiksmai su drobe",
    "selectedShapeActions": "Veiksmai su pasirinkta figūra",
    "shapes": "Figūros"
  },
  "hints": {
    "dismissSearch": "",
    "canvasPanning": "",
    "linearElement": "Paspaudimai sukurs papildomus taškus, nepertraukiamas tempimas sukurs liniją",
    "arrowTool": "",
    "arrowBindModifiers": "",
    "freeDraw": "Spausk ir tempk, paleisk kai norėsi pabaigti",
    "text": "Užuomina: tekstą taip pat galima pridėti bet kur su dvigubu pelės paspaudimu, kol parinkas žymėjimo įrankis",
    "embeddable": "",
    "autoshape": "",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "toggleArrowhead": "",
    "lineEditor_info": "",
    "lineEditor_line_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "bindTextToElement": "",
    "createFlowchart": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "",
    "disableSnapping": "",
    "enterCropEditor": "",
    "leaveCropEditor": ""
  },
  "canvasError": {
    "cannotShowPreview": "",
    "canvasTooBig": "",
    "canvasTooBigTip": ""
  },
  "errorSplash": {
    "headingMain": "",
    "clearCanvasMessage": "",
    "clearCanvasCaveat": "",
    "trackedToSentry": "",
    "openIssueMessage": "",
    "sceneContent": ""
  },
  "shareDialog": {
    "or": ""
  },
  "roomDialog": {
    "desc_intro": "",
    "desc_privacy": "",
    "button_startSession": "Pradėti seansą",
    "button_stopSession": "Sustabdyti seansą",
    "desc_inProgressIntro": "",
    "desc_shareLink": "",
    "desc_exitSession": "",
    "shareTitle": ""
  },
  "errorDialog": {
    "title": "Klaida"
  },
  "progressDialog": {
    "title": "",
    "defaultMessage": ""
  },
  "exportDialog": {
    "disk_title": "Įrašyti į diską",
    "disk_details": "",
    "disk_button": "Įrašyti į failą",
    "link_title": "Nuoroda dalinimuisi",
    "link_details": "",
    "link_button": "",
    "excalidrawplus_description": "",
    "excalidrawplus_button": "Eksportuoti",
    "excalidrawplus_exportError": ""
  },
  "helpDialog": {
    "blog": "",
    "click": "paspaudimas",
    "deepSelect": "",
    "deepBoxSelect": "",
    "createFlowchart": "",
    "navigateFlowchart": "",
    "curvedArrow": "Banguota rodyklė",
    "curvedLine": "Banguota linija",
    "documentation": "Dokumentacija",
    "doubleClick": "dvigubas paspaudimas",
    "drag": "vilkti",
    "editor": "Redaktorius",
    "editLineArrowPoints": "",
    "editText": "",
    "github": "Radai klaidą? Pateik",
    "howto": "Vadovaukis mūsų gidu",
    "or": "arba",
    "preventBinding": "",
    "tools": "Įrankiai",
    "shortcuts": "Spartieji klavišai",
    "textFinish": "Baigti redagavimą (teksto redaktoriuje)",
    "textNewLine": "Pridėti naują eilutę (tekto redaktoriuje)",
    "title": "Pagalba",
    "view": "",
    "zoomToFit": "",
    "zoomToSelection": "Priartinti iki pažymėtos vietos",
    "toggleElementLock": "",
    "movePageUpDown": "Pajudinti puslapį aukštyn/žemyn",
    "movePageLeftRight": "Pajudinti puslapį kairėn/dešinėn",
    "cropStart": "",
    "cropFinish": ""
  },
  "clearCanvasDialog": {
    "title": "Išvalyti drobę"
  },
  "imageExportDialog": {
    "header": "",
    "label": {
      "withBackground": "",
      "onlySelected": "",
      "darkMode": "",
      "embedScene": "",
      "scale": "",
      "padding": ""
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    },
    "button": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    }
  },
  "encrypted": {
    "tooltip": "",
    "link": ""
  },
  "stats": {
    "angle": "",
    "shapes": "",
    "height": "Aukštis",
    "scene": "Scena",
    "selected": "Pasirinkta",
    "storage": "Saugykla",
    "fullTitle": "",
    "title": "",
    "generalStats": "",
    "elementProperties": "",
    "total": "",
    "version": "",
    "versionCopy": "",
    "versionNotAvailable": "",
    "width": "Plotis"
  },
  "toast": {
    "copyStyles": "",
    "copyToClipboard": "Nukopijuota į iškarpinę.",
    "copyToClipboardAsPng": "",
    "copyToClipboardAsSvg": "",
    "fileSaved": "Failas išsaugotas.",
    "fileSavedToFilename": "Išsaugota į {filename}",
    "canvas": "drobė",
    "selection": "",
    "pasteAsSingleElement": "",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": "",
    "elementLinkCopied": ""
  },
  "colors": {
    "transparent": "Permatoma",
    "black": "",
    "white": "",
    "red": "",
    "pink": "",
    "grape": "",
    "violet": "",
    "gray": "",
    "blue": "",
    "cyan": "",
    "teal": "",
    "green": "",
    "yellow": "",
    "orange": "",
    "bronze": ""
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "",
      "menuHint": ""
    },
    "defaults": {
      "menuHint": "",
      "center_heading": "",
      "toolbarHint": "",
      "helpHint": ""
    }
  },
  "colorPicker": {
    "color": "",
    "mostUsedCustomColors": "",
    "colors": "",
    "shades": "",
    "hexCode": "",
    "noShades": "",
    "invalidColor": "",
    "invalidHexLength": "",
    "topPicksTip": "",
    "resetTopPicks": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "",
        "button": "",
        "description": ""
      },
      "saveToDisk": {
        "title": "",
        "button": "",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "",
        "button": "",
        "description": ""
      },
      "shareableLink": {
        "title": "",
        "button": "",
        "description": ""
      }
    }
  },
  "quickSearch": {
    "placeholder": ""
  },
  "fontList": {
    "badge": {
      "old": ""
    },
    "sceneFonts": "",
    "availableFonts": "",
    "empty": ""
  },
  "userList": {
    "empty": "",
    "hint": {
      "text": "",
      "followStatus": "",
      "inCall": "",
      "micMuted": "",
      "isSpeaking": ""
    }
  },
  "keys": {
    "ctrl": "",
    "option": "",
    "cmd": "",
    "alt": "",
    "escape": "",
    "enter": "",
    "shift": "",
    "spacebar": "",
    "delete": "",
    "mmb": ""
  }
}
